<template>
    <div class="B2BGain container mt-20 flex flex-col items-center justify-between lg:mt-40 lg:flex-row">
        <div class="flex w-full flex-col items-center justify-center lg:w-1/2 lg:items-start">
            <CHeading class="mb-10 max-w-[500px]" tag="h2" variant="fat-italic">Čo môžete získať na platforme GROWNi</CHeading>

            <div class="flex w-full flex-col sm:w-[511px] lg:w-[362px]">
                <div
                    v-for="(item, idx) in items"
                    :key="`${item.icon}-${idx}`"
                    class="flex h-[72px] flex-row items-center justify-start border-t border-solid border-gray-200 dark:border-default"
                >
                    <CIcon class="mr-8 text-primary-910 dark:text-primary-300" :name="item.icon" />
                    <strong>{{ item.text }}</strong>
                </div>
            </div>
        </div>

        <div class="mt-4 flex w-full flex-row justify-center lg:mt-0 lg:w-1/2">
            <img
                alt="Čo môžete získať na platforme GROWNi - spolupraca"
                class="object-cover"
                src="@/assets/images/teamwork.png"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import { B2BType } from '#shared/types/B2B'
import CHeading from '@/components/ui/CHeading.vue'
import CIcon from '@/components/ui/CIcon.vue'

const ITEMS = {
    [B2BType.DEFAULT]: [
        { text: 'Rozvoj jednotlivcov a organizácií', icon: 'atom' },
        { text: 'Podpora rastúcich inovatívnych firiem', icon: 'rocket' },
        { text: 'Zlepšenie verejného sektora', icon: 'building' },
        { text: 'Zapojenie Slovákov žijúcich v zahraničí', icon: 'globe' }
    ],

    [B2BType.GOV]: [
        { text: 'Zapojenie Slovákov žijúcich v zahraničí', icon: 'globe' },
        { text: 'Rozvoj jednotlivcov a celých tímov ', icon: 'atom' },
        { text: 'Podpora rastúcich inovatívnych jednotiek', icon: 'rocket' },
        { text: 'Zlepšenie povedomia o činnosti verejného sektora', icon: 'building' }
    ],

    [B2BType.NGO]: []
} as const

const props = defineProps({
    type: {
        type: String as PropType<B2BType>,
        default: B2BType.DEFAULT
    }
})

const items = computed(() => ITEMS[props.type])
</script>
